/* eslint-disable no-unused-vars */
const beige1 = '#F4F4EE';
const navy1 = '#2951CE';
const navy2 = '#063d8f';
const navy3 = '#03295F';
const navy4 = '#367FFF';
const navy5 = '#003A90';
const navy6 = 'rgb(6, 50, 135)';
const navy7 = '#5593FF';
const blue10 = '#ecf6ff';
const blue1 = '#084DA8';
const red1 = '#FF0000';
const red2 = '#ED4850';
const red3 = '#EB5757';
const white1 = '#FFFFFF';
const black1 = '#000000';
const charcoal1 = '#2d2d2d';
const gold1 = '#F7AE41';
const taupe1 = '#E8E8DC';
const taupe2 = '#C3C3B9';
const taupe3 = '#5B5B5B';
const taupe4 = '#E5E5DE';
const green1 = '#2CB669';
const orange1 = '#FD5C36';
const orange2 = '#f76324';
const orange3 = '#F66324';
const skyBlue1 = '#E0EDF9';
const grey1 = '#9A9A9A';
const grey2 = '#B4C0D1';
const grey3 = '#C3C3B97F';
const grey4 = '#898A8D';

export default {
  primaryAppBackground: beige1,
  splashBackground: navy2,
  wholeMeAssets: {
    primary: navy4,
    splashBackground: navy5,
    splashTitle: navy7,
    mobileSplashBackground: navy6,
    videoPlayerBackground: black1,
  },
  buttons: {
    primaryBackground: navy1,
    secondaryBackground: navy2,
    tetriaryBackground: navy3,
    warnigBackground: red1,
    successBackground: green1,
    uploadMediaBackground: skyBlue1,
    uploadStoryBackground: navy4,
    profileSaveButton: navy3,
    whiteBackground: white1,
    disabledButton: taupe2,
    selectedButtonOutline: beige1,
    lightGrey: grey3,
    deleteRedButton: red3,
  },
  cards: {
    secondaryBackground: taupe4,
  },
  text: {
    lightTaupe: taupe1,
    taupe: taupe2,
    darkTaupe: taupe3,
    darkNavy: navy3,
    navy: navy2,
    whiteText: white1,
    blackText: black1,
    uploadMediaText: navy3,
    darkButtonText: taupe3,
    lightButtonText: taupe1,
    highlightText: red2,
    lightBlack: charcoal1,
    red: red1,
    grey: grey1,
    greenSuccess: green1,
    gold: gold1,
    placeholderGrey: grey4,
  },
  icon: {
    grey: grey1,
    taupe: taupe2,
    greenSuccess: green1,
  },
  container: {
    white: white1,
    beige: beige1,
    darkNavy: navy3,
    orange: orange1,
    electricBlue: navy4,
    primaryBorder: black1,
    secondaryBorder: navy4,
    splashBackground: blue1,
  },
  pills: {
    skyBlue: navy4,
    lightBlue: navy2,
    darkBlue: navy3,
    green: green1,
    gold: gold1,
    lightBlack: charcoal1,
    orange: orange2,
    orange2: orange3,
    white: white1,
  },
  selectInput: {
    backgroundColor: white1,
    greyDivider: grey2,
    selected: taupe1,
    radioSelect: navy2,
  },
  inputs: {
    primaryBackground: blue10,
  },
};
